import { TextField, TextFieldProps } from '@mui/material';

function Message(props: TextFieldProps) {
	return <TextField multiline rows={4} {...props} />;
}

export default Message;
